"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initBlizzardWebClient = exports.setBlizzardHasBeenInitialized = exports.hasBlizzardBeenInitialized = void 0;
const blizzard_1 = require("@snapchat/blizzard");
const web_extraction_1 = require("@snapchat/web-extraction");
const web_log_1 = require("@snapchat/web-log");
const graphene_1 = __importDefault(require("@snapchat/graphene"));
const observable_1 = require("./utils/observable");
const authState_1 = require("@snapchat/blizzard/lib/auth/authState");
const ssoClientConfig_1 = require("@snapchat/blizzard/lib/auth/ssoClientConfig");
const web_sc_cookies_1 = require("@snapchat/web-sc-cookies");
exports.hasBlizzardBeenInitialized = false;
function setBlizzardHasBeenInitialized(setVal) {
    exports.hasBlizzardBeenInitialized = setVal;
}
exports.setBlizzardHasBeenInitialized = setBlizzardHasBeenInitialized;
const SNAPCHAT_COM_METRICS_SSO_URL = "https://accounts.snapchat.com/accounts/sso?client_id=snapchat-com-metrics";
const authState = new observable_1.Observable(authState_1.UNSET_AUTH_STATE);
function callAccountsSSO(isProd) {
    // Avoid calling /accounts/sso if nonce cookie is not set
    if (isProd && !(0, web_sc_cookies_1.hasNonceCookieSet)()) {
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: "BlizzardEvents.InitBlizzard.NonceCookieNotSet",
                value: 1,
            });
        }
        authState.next(authState_1.UNAUTH_STATE);
        return;
    }
    fetch(SNAPCHAT_COM_METRICS_SSO_URL, {
        method: "POST",
        // include the necessary accounts cookies with the request
        credentials: "include",
        keepalive: true,
        // dont automatically follow redirects to the login page if user is not logged-in
        redirect: "manual",
    })
        .then((resp) => {
        if (resp.status === 200) {
            void resp.text().then((ssoToken) => {
                authState.next({
                    authStatus: authState_1.AuthStatus.AUTHENTICATED,
                    ssoToken,
                });
            });
        }
        else {
            authState.next(authState_1.UNAUTH_STATE);
        }
    })
        .catch((e) => {
        authState.next(authState_1.UNAUTH_STATE);
        if (graphene_1.default.isReady()) {
            graphene_1.default.increment({
                metricsName: "BlizzardEvents.InitBlizzard.AuthTokenFetchFailed",
                value: 1,
            });
        }
        web_log_1.log.error(e);
    });
}
function subscribeToSnapchatComMetricsSSO(isProd) {
    callAccountsSSO(isProd);
    // try and fetch SSO token every 2 minutes if user is still on page
    setInterval(() => callAccountsSSO(isProd), 120000);
}
function initBlizzardWebClient(config) {
    if (!exports.hasBlizzardBeenInitialized) {
        // use UA data to identify device type and default to assuming user is on mobile
        // we can't use the useMediaQuery hook as we render mobile by default first so desktop
        // views are also tagged as mobile using that approach
        const isDesktop = (0, web_extraction_1.isDesktopUA)();
        const appVersion = process.env.NEXT_PUBLIC_APP_VERSION;
        (0, blizzard_1.initBlizzard)({
            debugLoggingEnabled: !config.isProd,
            appEnvironment: {
                appType: isDesktop ? "WEB_DESKTOP" : "WEB_MOBILE",
                appBuild: "PROD",
                appVersion,
            },
            clientAuthProvider: {
                ssoClientId: ssoClientConfig_1.SsoClientId.SNAPCHAT_COM,
                authState,
            },
            mode: blizzard_1.CollectionMode.PROD,
            lifecycleConfig: {
                reportWebPageOpen: config.withWebPageOpen,
            },
            cookiesDisabled: true,
            metricsAppId: config.metricsAppId,
        });
        if (config.withWebPageOpen) {
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.WithWebPageOpen",
                    value: 1,
                });
            }
            subscribeToSnapchatComMetricsSSO(config.isProd);
        }
        else {
            if (graphene_1.default.isReady()) {
                graphene_1.default.increment({
                    metricsName: "BlizzardEvents.InitBlizzard.WithoutWebPageOpen",
                    value: 1,
                });
            }
        }
        setBlizzardHasBeenInitialized(true);
    }
}
exports.initBlizzardWebClient = initBlizzardWebClient;
//# sourceMappingURL=blizzard.js.map